import React from "react";
import Header from "../../UserManagement/Components/Header";

const BrokerMetricsTab = () => {
  return (
    <div>
      <div>
        <Header
          title={"Broker Metrics"}
          // subTitle={"Product revenue, platform fees, and commission tracking"}
        />
      </div>
    </div>
  );
};

export default BrokerMetricsTab;
